﻿import Helpers from "../../../../../Site/gulp/scripts/typescript/modules/helpers";

export default class HelpButtonVoting {

	constructor() {

		this.attachEvents();
	}

	private attachEvents() {

		const triggerButtons = document.querySelectorAll('.js-help-vote');

		Helpers.scopedLoop(triggerButtons, (item, i, context) => {

			item.addEventListener('click', () => {

				for (let i = 0; i < triggerButtons.length; i++) {
					triggerButtons[i].classList.remove('is-selected');
				}
				item.classList.add('is-selected');
				this.showVotedMessage();
				this.trackClick(item.getAttribute('data-vote'));

			});

		}, this);

	}

	private showVotedMessage() {
		const votedMessage = document.querySelector('.js-help-vote-message');
		if (votedMessage) {
			votedMessage.setAttribute('aria-hidden', 'false');
		}
	}

	public trackClick(vote: string) {
		(<any>window).dataLayer = (<any>window).dataLayer || [];
		(<any>window).dataLayer.push({
			event: 'eventTracking',
			eventCategory: 'Help Hub',
			eventAction: 'Vote',
			eventLabel: vote
		});
	}

}
